import { useNavigate, useParams } from 'react-router-dom';
import { BaseButton, useT } from '@repo/common';
import { ReactComponent as SuccessIcon } from '@repo/common/assets/icons/32px/icon_32px_check-circle_filled.svg';

export default function RefundSuccess() {
  const t = useT();
  const navigate = useNavigate();
  const { invoiceNumber } = useParams();

  return (
    <div className='flex flex-col items-center justify-center flex-1 w-full min-h-screen p-10 pb-[160px]'>
      <div className='flex flex-col items-center'>
        {/* 체크 아이콘 */}
        <div className='pb-6'>
          <div className='relative flex items-center justify-center w-[90px] h-[90px] rounded-full border-[24px] border-green-light02'>
            <SuccessIcon
              width={60}
              height={60}
              className='absolute z-10 text-icon-success'
            />
          </div>
        </div>

        <div className='flex flex-col gap-1 pb-10'>
          <h1 className='typo-h7 text-text-primary'>
            {t('Refund request submitted', '환불 요청이 접수되었습니다')}
          </h1>
          <p className='text-center typo-b16 text-text-primary'>
            {t(
              'Your refund request has been submitted successfully.',
              '환불 요청이 정상적으로 접수되었습니다.',
            )}
            <br />
            {t(
              'You can track the status in your invoice or My Page.',
              '인보이스 또는 마이페이지에서 진행 상태를 확인하실 수 있습니다.',
            )}
          </p>
        </div>

        <div className='flex flex-col items-center w-[280px] gap-2'>
          <BaseButton
            type='text_basic'
            size='l'
            hideIcon
            width='100%'
            onClick={() =>
              navigate(`/mypage?invoice=${invoiceNumber}`, { replace: true })
            }
          >
            {t('View Invoice', '인보이스 보기')}
          </BaseButton>
          <BaseButton
            type='text_basic'
            size='l'
            hideIcon
            width='100%'
            onClick={() =>
              navigate('/community/kpathport/pathfeed', { replace: true })
            }
          >
            {t('Browse Workshops', '워크숍 둘러보기')}
          </BaseButton>
        </div>
      </div>
    </div>
  );
}
